export namespace LotTranslations {
  export const common = {
    lot: 'lot',
    lotExpiry: 'lotExpiry',
  } as const;

  export const error = {
    lotsUnableToLoadError: 'lotsUnableToLoadError',
  } as const;
}
